
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLightBulb = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.624 1c3.82 0 6.988 3.253 7.012 7.246 0 2.415-1.165 4.519-2.795 5.738v1.794c0 .502-.42.909-.91.956l-6.405.527h-.093a.943.943 0 0 1-.653-.263c-.186-.167-.35-.43-.35-.693V13.96c-1.863-1.315-2.794-3.276-2.794-5.715C4.636 4.253 7.804 1 11.624 1Zm0 1.913c-2.819 0-5.125 2.392-5.102 5.333 0 1.96.746 3.395 2.353 4.352a.99.99 0 0 1 .42.837v1.841l4.658-.382v-1.46c0-.334.164-.669.467-.836 1.467-.813 2.306-2.44 2.329-4.352 0-2.941-2.306-5.333-5.125-5.333Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.42 12.598c-.303.167-.466.502-.466.837v1.458l-4.66.383v-1.841c0-.335-.14-.646-.419-.837-1.607-.957-2.352-2.391-2.352-4.352-.024-2.942 2.283-5.333 5.101-5.333 2.819 0 5.125 2.391 5.125 5.333-.023 1.913-.862 3.539-2.33 4.352Z",
  fill: "var(--theme-light,#e2cff7)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m14.863 19.796-6.36.478h-.07c-.489 0-.885-.383-.931-.885a.954.954 0 0 1 .861-1.028l6.36-.479a.918.918 0 0 1 1.002.885.953.953 0 0 1-.862 1.029ZM12.836 22.809l-2.283.19h-.07c-.49 0-.885-.382-.932-.884a.954.954 0 0 1 .862-1.028l2.306-.191a.926.926 0 0 1 .979.884.954.954 0 0 1-.862 1.029ZM15.329 8.222c-.047.43-.397.765-.816.765h-.07a.825.825 0 0 1-.722-.909c.14-1.363-1.025-1.865-1.165-1.913a.87.87 0 0 1-.489-1.076c.14-.43.606-.67 1.025-.502.862.31 2.446 1.483 2.236 3.635Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M11.624 1C15.4443 1 18.6124 4.25262 18.6357 8.24609C18.6356 10.6609 17.4711 12.7648 15.8408 13.9844V15.7783C15.8408 16.2805 15.4208 16.6866 14.9316 16.7344L8.52637 17.2607H8.43262C8.19971 17.2607 7.9433 17.1654 7.78027 16.998C7.594 16.8307 7.4308 16.5676 7.43066 16.3047V13.9609C5.56738 12.6458 4.63585 10.6849 4.63574 8.24609C4.63574 4.25264 7.80376 1.00004 11.624 1ZM11.624 2.91309C8.80544 2.91315 6.49917 5.30483 6.52246 8.24609C6.52258 10.2066 7.26804 11.6412 8.875 12.5977C9.15448 12.7889 9.29487 13.0999 9.29492 13.4346V15.2764L13.9531 14.8936V13.4346C13.9532 13.0999 14.1172 12.765 14.4199 12.5977C15.8871 11.7846 16.7256 10.1588 16.749 8.24609C16.749 5.30479 14.4427 2.91309 11.624 2.91309Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M14.4195 12.5979C14.1166 12.7653 13.9536 13.1 13.9536 13.4348V14.8935L9.29468 15.2761V13.4348C9.29468 13.1 9.15492 12.7892 8.87538 12.5979C7.26806 11.6413 6.52264 10.2066 6.52264 8.24569C6.49934 5.30439 8.8055 2.91309 11.6241 2.91309C14.4428 2.91309 16.7489 5.30439 16.7489 8.24569C16.7256 10.1587 15.887 11.7848 14.4195 12.5979Z\" fill=\"var(--theme-light,#e2cff7)\"/>\r\n<path d=\"M14.8626 19.7955L8.50319 20.2738H8.43331C7.94413 20.2738 7.54812 19.8912 7.50153 19.389C7.45494 18.8629 7.85095 18.4086 8.36343 18.3607L14.7228 17.8825C15.2586 17.8347 15.7012 18.2412 15.7245 18.7673C15.7711 19.2934 15.3751 19.7477 14.8626 19.7955Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M12.8359 22.8086L10.553 22.9999H10.4831C9.99393 22.9999 9.59792 22.6173 9.55133 22.1152C9.50475 21.5891 9.90075 21.1347 10.4132 21.0869L12.7194 20.8956C13.2319 20.8717 13.6745 21.2543 13.6978 21.7804C13.7443 22.3065 13.3483 22.7608 12.8359 22.8086Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M15.3285 8.22173C15.2819 8.65217 14.9325 8.98695 14.5132 8.98695H14.4433C14.0007 8.93912 13.6746 8.5326 13.7212 8.07825C13.861 6.71521 12.6962 6.21304 12.5565 6.16521C12.1372 5.99782 11.9275 5.51956 12.0673 5.08912C12.2071 4.65869 12.6729 4.41956 13.0922 4.58695C13.9541 4.89782 15.5382 6.06956 15.3285 8.22173Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/lightBulb.e8312b8e8d94b0014978eccc359136ed.svg"),
        {
          React: SvgLightBulb,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      